<section class="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-10">
  <div class="rounded-2xl border border-sky-100 bg-gradient-to-br from-sky-50 via-white to-cyan-50 p-5 shadow-sm sm:p-7 lg:p-8">
    <div class="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
      <div class="max-w-2xl">
        <h1 class="text-2xl font-bold text-slate-900 sm:text-3xl">Ihr Gartenwasserzähler-Bereich</h1>
        <p class="mt-2 text-sm text-slate-600 sm:text-base">
          Verwalten Sie Ihre Zähler und verfolgen Sie Ihre Anträge an einem Ort.
          Neue Anträge können Sie direkt hier erstellen.
        </p>
      </div>

      <button
        type="button"
        class="button-primary w-full shrink-0 sm:w-auto"
        [routerLink]="['/neuerZaehlerBeantragen']">
        Neuen Zähler beantragen
      </button>
    </div>
  </div>

  <div class="mt-6 grid grid-cols-1 gap-6 lg:mt-8 lg:gap-8">
    <section class="rounded-xl border border-gray-100 bg-white p-4 shadow-sm sm:p-6">
      <app-liste-zaehler-component></app-liste-zaehler-component>
    </section>

    <section class="rounded-xl border border-gray-100 bg-white p-4 shadow-sm sm:p-6">
      <app-liste-zaehler-antraege-component></app-liste-zaehler-antraege-component>
    </section>
  </div>
</section>
